export default "__VITE_ASSET__W1CG$KMv__"